export const SITE_MODULATORS_COUNT_CARD_FRENCH_LOCALE = {
  title: "Modulateurs",
  subtitle: "Sur site",
  seeMore: "Voir plus",
};
